// extracted by mini-css-extract-plugin
export default {"title":"Applicate_title_yn9WJ","links":"Applicate_links_rsIsT","link":"Applicate_link_oRrtY"};